// Keeps the product gallery in step with the selected color: when a shopper picks an option,
// the swipeable mobile gallery slides to that variant's photo (and opens on it on page load).
const gallery = document.querySelector('[data-product-gallery]');

let mediaMap = {};
try {
  mediaMap = JSON.parse(document.querySelector('[data-variant-media-map]')?.textContent || '{}');
} catch (e) {
  mediaMap = {};
}

let lastMediaId = null;

function showMedia(mediaId, smooth) {
  if (!gallery || !mediaId || mediaId === lastMediaId) return;
  const slide = gallery.querySelector(`[data-media-id="${mediaId}"]`);
  if (!slide) return;
  lastMediaId = mediaId;
  // Only the mobile gallery scrolls sideways; the desktop grid already shows every photo.
  if (gallery.scrollWidth <= gallery.clientWidth + 1) return;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const slides = Array.from(gallery.querySelectorAll(":scope > [data-media-id]"));
  const left = slides.indexOf(slide) * gallery.clientWidth;
  gallery.scrollTo({ left, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
}

function showVariant(variantId, smooth) {
  if (variantId) showMedia(mediaMap[String(variantId)], smooth);
}

function currentVariantId() {
  const marker = document.querySelector('[data-product-form] input[name="id"]');
  return new URL(location.href).searchParams.get('variant') || marker?.value;
}

if (gallery) {
  // Open on the selected variant's photo.
  showVariant(currentVariantId(), false);

  // Respond the instant a color or size is picked.
  document.addEventListener('change', (event) => {
    const control = event.target;
    if (!(control instanceof HTMLElement) || !control.closest('s-variant-picker')) return;
    let variantId = control.dataset.variantId;
    if (control instanceof HTMLSelectElement) {
      variantId = control.selectedOptions[0]?.dataset.variantId;
    }
    lastMediaId = null;
    showVariant(variantId, true);
  });

  // After the page refreshes the selected variant, confirm the photo still matches.
  const form = document.querySelector('[data-product-form]');
  if (form) {
    new MutationObserver(() => {
      const id = form.querySelector('[data-selected-media-id]')?.dataset.selectedMediaId;
      if (id) showMedia(id, true);
    }).observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-selected-media-id', 'value'] });
  }
}
